import React from 'react';

const TriggerStepContext = React.createContext({});

export default TriggerStepContext;
